import { ReactNode } from 'react'

import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverContentProps,
  PopoverProps,
  PopoverTrigger,
} from '@chakra-ui/react'

import { PropsWithChildrenRequired } from 'constants/typings'
import { useIsOnTouchscreen } from 'hooks/useIsOnTouchscreen'
import { Popover as PopoverTheme } from 'theme/components/Popover'

type Variants = (typeof PopoverTheme)['variants']

interface TooltipProps {
  content: ReactNode
  boxShadow?: PopoverContentProps['boxShadow']
  placement?: PopoverProps['placement']
  isDisabled?: boolean
  variant?: keyof Variants
}

export const Tooltip = ({
  children,
  content,
  placement = 'top',
  variant = 'tooltip',
  boxShadow,
  isDisabled,
}: PropsWithChildrenRequired<TooltipProps>) => {
  const isOnTouchscreen = useIsOnTouchscreen()

  return (
    <Popover
      placement={placement}
      variant={variant}
      trigger={isOnTouchscreen ? 'click' : 'hover'}
      colorScheme="white"
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent
        {...(isDisabled && { display: 'none' })}
        w="auto"
        maxW="300px"
        {...(boxShadow && {
          boxShadow,
          _focus: { boxShadow },
        })}
      >
        <PopoverArrow bg="black" />
        <PopoverBody textAlign="center">{content}</PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
